import {
    FaHotel,
    FaMoneyBillWave,
    FaHeadset,
    FaMapMarkedAlt
} from "react-icons/fa";

export default function WhyChooseUs() {
    const features = [
        {
            icon: <FaHotel size={28} />,
            title: "Premium Hotels",
            desc: "Carefully selected luxury hotels and resorts offering exceptional comfort and unforgettable experiences."
        },
        {
            icon: <FaMoneyBillWave size={28} />,
            title: "Best Price Guarantee",
            desc: "Enjoy competitive pricing and exclusive hotel deals with no hidden charges."
        },
        {
            icon: <FaHeadset size={28} />,
            title: "24/7 Customer Support",
            desc: "Our travel specialists are available around the clock to assist with bookings and inquiries."
        },
        {
            icon: <FaMapMarkedAlt size={28} />,
            title: "Top Dubai Locations",
            desc: "Stay close to Dubai's most popular attractions, beaches, shopping malls and business hubs."
        }
    ];

    return (
        <section className="py-10 sm:py-12 md:py-16 lg:py-20 bg-gradient-to-b from-white to-orange-50/30">

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                {/* Heading */}
                <div className="text-center mb-14">

                    <span className="inline-flex items-center px-4 py-2 rounded-full bg-orange-100 text-[#0F172A] text-sm font-semibold mb-4">
                        Why Book With Us
                    </span>

                    <h2 className="text-3xl md:text-4xl font-bold text-slate-900">
                        Travel Smarter, Stay Better
                    </h2>

                    <p className="max-w-2xl mx-auto mt-4 text-slate-500">
                        Discover unbeatable hotel deals, trusted accommodation
                        options and dedicated support for a seamless Dubai stay.
                    </p>

                </div>

                {/* Features */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">

                    {features.map((item, index) => (
                        <div
                            key={index}
                            className="group bg-white rounded-[28px] p-8 border border-orange-100 shadow-xl hover:shadow-2xl hover:-translate-y-2 transition-all duration-500"
                        >

                            {/* Icon */}
                            <div className="w-16 h-16 rounded-2xl bg-orange-100 text-[#0F172A] flex items-center justify-center mb-6 group-hover:bg-[#0F172A] group-hover:text-white transition-all duration-300">
                                {item.icon}
                            </div>

                            {/* Title */}
                            <h3 className="text-xl font-bold text-slate-900 mb-3">
                                {item.title}
                            </h3>

                            {/* Description */}
                            <p className="text-slate-500 leading-relaxed text-sm">
                                {item.desc}
                            </p>

                        </div>
                    ))}

                </div>

            </div>

        </section>
    );
}